module.exports =
  methods:
    mergeCurrentUserFilterIfSeller: (filters = {}) ->
      if Session.current_user.isSeller()
        @mergeCurrentUserFilter(filters)
      else
        filters

    mergeCurrentUserFilter: (filters = {}, user_id=null) ->
      id = if user_id then user_id else Session.current_user.id
      jQuery.extend({}, filters, { user_id_eq: id })

    setFiltersFromQueryParams: ->
      @filters = @$router.currentRoute.query

    applyFiltersOnUrlQueryParams: (filters={}) ->
      serializedQueryParams = jQuery.param(filters)

      path = @$router.currentRoute.path
      path += "?#{serializedQueryParams}" if serializedQueryParams
      window.history.pushState({path: path}, '', path)

    extractFilter: (key) ->
      if @filters[key]
        obj = {}
        obj[key] = @filters[key]
        obj
      else
        null



// WEBPACK FOOTER //
// ./src/helpers/filters.coffee